import React from 'react';
import { connect } from 'react-redux';
import { resetPlayback, getNvrTimestamp } from '../actions';
import HeaderButtonGroup from './HeaderButtonGroup';
import '../App.css';
import SearchContainer from './SearchContainer';
import PlayerWindow from './PlayerWindow';
import ClipContainer from './ClipContainer';
// import moment from 'moment';

class Playback extends React.Component {
  constructor(props) {
      super(props);

      this.state = {
        timestampHandlerRunning: false
      };
      this.nvrTimestampHandler = 0;
  };

  componentDidMount = () => {
    this.props.resetPlayback();
    clearInterval(this.nvrTimestampHandler);
    if(!this.state.timestampHandlerRunning){
      this.startNvrTimeUpdate()    
    }     
  }

  componentWillUnmount = () => {
    clearInterval(this.nvrTimestampHandler);
    this.setState({ timestampHandlerRunning: false })
  }

  startNvrTimeUpdate = () => {
    this.nvrTimestampHandler = setInterval(() => this.props.getNvrTimestamp(this.props.sSess), 1000);
  }
    
  render() {
    const { 
      playbackContainerStyle
    } = styles;
    return (
        <div style={ playbackContainerStyle }>
            <HeaderButtonGroup />
            <SearchContainer />
            <PlayerWindow />
            <ClipContainer />
      </div>
    );
  };
};

const mapStateToProps = state => {
  const { isLoggedIn, sSess } = state.auth;
    return {
        isLoggedIn,
        sSess
    }
};

export default connect(mapStateToProps, { resetPlayback, getNvrTimestamp })(Playback);

const styles = {
  playbackContainerStyle: {
    width: '100%',
    height: '100vh',
    backgroundColor: 'rgba(10,14,25,0.7)'
  }
  
};
